import { styled } from "@mui/material/styles";
import Switch from "@mui/material/Switch";

const CustomSwitchStyled = styled(Switch)(({ theme }) => ({
  width: 36,
  height: 20,
  padding: 0,
  display: "flex",
  "&:active": {
    "& .MuiSwitch-thumb": {
      width: 15,
    },
    // "& .MuiSwitch-switchBase.Mui-checked": {
    //   transform: "translateX(9px)",
    // },
  },
  "& .MuiSwitch-switchBase": {
    padding: 2,
    "&.Mui-checked": {
      transform: "translateX(17px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: "#212121",
      },
    },
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
    width: 16,
    height: 16,
    borderRadius: 20,
    transition: theme.transitions.create(["width"], {
      duration: 200,
    }),
  },
  "& .MuiSwitch-track": {
    borderRadius: 20,
    opacity: 1,
    backgroundColor: "#F2F4F7",
    boxSizing: "border-box",
  },
}));

export default function   CustomSwitch({ checked, onClick, className }: any) {
  return <CustomSwitchStyled checked={checked} onClick={onClick} className={className} />;
}
